var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalir(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.6 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b2b2b2;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5,12.6a5.2,5.2,0,0,0,2.3.6c1.3,0,2.1-.7,2.1-1.7s-.6-1.4-1.9-1.9-2.6-1.5-2.6-2.8,1.3-2.7,3.2-2.7a4.2,4.2,0,0,1,2.2.5l-.4,1a3.6,3.6,0,0,0-1.9-.5c-1.3,0-1.8.8-1.8,1.5s.6,1.4,1.9,1.9,2.6,1.5,2.6,2.9-1.2,2.9-3.5,2.9a4.4,4.4,0,0,1-2.5-.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2,11l-1,3.1H37.9l3.3-9.9h1.6l3.3,9.9H44.8L43.7,11Zm3.3-1-1-2.8c-.2-.7-.4-1.3-.5-1.8h0c-.2.6-.3,1.2-.5,1.8l-1,2.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3,4.2h1.3V13h4.2v1.1H49.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3,4.2v9.9H58V4.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2,4.4a9.7,9.7,0,0,1,2.5-.2,3.8,3.8,0,0,1,2.8.8,2.3,2.3,0,0,1,.8,1.8,2.7,2.7,0,0,1-1.9,2.6h0a2.5,2.5,0,0,1,1.5,2,15.7,15.7,0,0,0,.7,2.7H68.3a12.8,12.8,0,0,1-.6-2.4c-.3-1.3-.8-1.8-2-1.9H64.5v4.3H63.2Zm1.3,4.5h1.3C67.2,8.9,68,8.1,68,7s-.9-1.8-2.2-1.9a3.1,3.1,0,0,0-1.3.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1,18H.9a.9.9,0,0,1-.8-.8V14.3a.8.8,0,0,1,.8-.8.8.8,0,0,1,.8.8v2.1H20.3V1.6H1.7V3.7a.9.9,0,0,1-.8.8.9.9,0,0,1-.8-.8V.8A.9.9,0,0,1,.9,0H21.1a.9.9,0,0,1,.8.8V17.2A.9.9,0,0,1,21.1,18Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3,8.9,9.8,5.8H9.7V8.3H1.5a.7.7,0,0,0,0,1.4H9.7v2.5h.1l3.5-3.1C13.4,9,13.4,8.9,13.3,8.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9,9.8H.8A.9.9,0,0,1,0,9a.8.8,0,0,1,.8-.8H9.9a.8.8,0,0,1,.8.8A.9.9,0,0,1,9.9,9.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalir);
export default __webpack_public_path__ + "static/media/salir.97e20724.svg";
export { ForwardRef as ReactComponent };